import _classCallCheck from "/jenkins/workspace/jenkins-prod-pipelines-LOS-UI-Login-UI-prod-10/packages/react-scripts/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/jenkins/workspace/jenkins-prod-pipelines-LOS-UI-Login-UI-prod-10/packages/react-scripts/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/jenkins/workspace/jenkins-prod-pipelines-LOS-UI-Login-UI-prod-10/packages/react-scripts/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/jenkins/workspace/jenkins-prod-pipelines-LOS-UI-Login-UI-prod-10/packages/react-scripts/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/jenkins/workspace/jenkins-prod-pipelines-LOS-UI-Login-UI-prod-10/packages/react-scripts/node_modules/@babel/runtime/helpers/esm/inherits";
import React, { PureComponent } from "react";
import { withStyles } from "@material-ui/core/styles";
import SwipeableViews from "react-swipeable-views";
import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";

var styles = function styles(theme) {
  return {
    root: {
      width: "100%",
      height: "100%",
      paddingTop: 20
    },
    swipe: {
      width: "100%",
      height: "calc(100% - 48px)",
      "& > .react-swipeable-view-container": {
        height: "100%"
      }
    },
    tab: {
      "& span": {
        fontSize: 12
      }
    }
  };
};

var DefiTabs =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(DefiTabs, _PureComponent);

  function DefiTabs() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, DefiTabs);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(DefiTabs)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.state = {
      value: _this.props.defaultTab
    };

    _this.handleChange = function (event, value) {
      _this.setState({
        value: value
      });
    };

    _this.handleChangeIndex = function (index) {
      _this.setState({
        value: index
      });
    };

    _this.createLabel = function (tab, i) {
      if (tab.activeTitle) {
        if (_this.state.value === i) {
          return tab.activeTitle;
        }
      }

      return tab.title;
    };

    return _this;
  }

  _createClass(DefiTabs, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          classes = _this$props.classes,
          children = _this$props.children;
      return React.createElement("div", {
        className: classes.root
      }, React.createElement(AppBar, {
        position: "static",
        color: "default"
      }, React.createElement(Tabs, {
        value: this.state.value,
        onChange: this.handleChange,
        indicatorColor: "primary",
        textColor: "primary",
        variant: "fullWidth"
      }, children.map(function (tab, i) {
        return React.createElement(Tab, {
          className: classes.tab,
          label: _this2.createLabel(tab.props, i),
          key: i
        });
      }))), React.createElement(SwipeableViews, {
        axis: "x",
        index: this.state.value,
        onChangeIndex: this.handleChangeIndex,
        className: classes.swipe
      }, children.map(function (tab) {
        return tab;
      })));
    }
  }]);

  return DefiTabs;
}(PureComponent);

export default withStyles(styles)(DefiTabs);